import script from "./AccessDeniedView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessDeniedView.vue?vue&type=script&setup=true&lang=js"

import "./AccessDeniedView.vue?vue&type=style&index=0&id=5adcf114&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adcf114"]])

export default __exports__